<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <a href="/" class="navbar-brand">GGPoker</a>
      <div class="navbar-nav mr-auto">
        <div v-if="showAdminBoard" style="display: none;"></div>
        <li v-if="currentUser" class="nav-item">
          <router-link to="/transaction" class="nav-link">Transações</router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/balance" class="nav-link">Saldos</router-link>
        </li>
        <li v-if="showModeratorBoard" class="nav-item">
          <router-link to="/users" class="nav-link">Usuário</router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/sendbalance" class="nav-link">Envia Saldo</router-link>
        </li>
        <li v-if="currentUser" class="nav-item">
          <router-link to="/sendmoney" class="nav-link">Envia Pix</router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link v-if="currentUser" to="/register" class="nav-link">Novo Usuário</router-link>
        </li>
      </div>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" /> Login
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/profile" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.username }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/changepwd" class="nav-link">
            <font-awesome-icon icon="user" />
            Trocar senha
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" /> Sair
          </a>
        </li>
      </div>
    </nav>

    <div class="container">
      <router-view />
    </div>
  </div>
</template>
<style scoped>
  .navbar{
    overflow: overlay;
  } 
</style>
<script>
export default {
  computed: {
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }
      
      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR');
      }
      
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  }
};
</script>
